import { Container, Row, Col } from 'react-bootstrap'

function About() {
  return (
    <div>
      <h2>About Bagel</h2>
      <Row className="mt-4">
        <Col lg={8}>
          <p>
            Bagel is a trust-based search engine that helps you discover and curate
            content based on recommendations from people you trust.
          </p>
          <h4 className="mt-4">How It Works</h4>
          <p>
            Instead of relying solely on algorithms, Bagel uses your personal trust
            network to surface content that matters to you. You can score websites,
            build trust relationships, and benefit from the collective knowledge of
            your network.
          </p>
          <h4 className="mt-4">Key Features</h4>
          <ul>
            <li><strong>Trust-Based Search</strong> - Find content recommended by people you trust</li>
            <li><strong>Personal Curation</strong> - Score and organize websites that matter to you</li>
            <li><strong>Trust Networks</strong> - Build and manage relationships with other curators</li>
            <li><strong>Multiple Profiles</strong> - Maintain separate profiles for different interests</li>
            <li><strong>Trust Lists</strong> - Subscribe to curated lists from trusted sources</li>
          </ul>
        </Col>
      </Row>
    </div>
  )
}

export default About
